import { useContext } from "react";

import appStyles from "../../../App.module.css";
import { CorporateGroupTravelContext } from "../../CorporateGroupTravel";
import { totalDays } from "../../config/cgConstants";
import { ICorporateGroupTravelContext } from "../../config/interfaces";

import { formatAmount } from "../../../app-constants";
import BackArrowIcon from "../icons/BackArrowIcon";
import CalendarIcon from "../icons/CalendarIcon";
import CheckIcon from "../icons/CheckIcon";
import HeartInsuranceIcon from "../icons/HeartInsuranceIcon";
import LocationIcon from "../icons/LocationIcon";
import UsersIcon from "../icons/UsersIcon";
import ProgressBar from "../page/ProgressBar";
const CGQuoteDetail = () => {
  const { quoteResult, quoteData, previous, next } = useContext(
    CorporateGroupTravelContext
  ) as ICorporateGroupTravelContext;

  const quoteAmount = formatAmount(
    quoteResult?.quoted_price || 0,
    quoteResult?.host_country || "US",
    quoteResult?.currency_id || "USD"
  );
  const isDecimal = quoteAmount.indexOf(".");

  return (
    <>
      <ProgressBar />
      <div className={`${appStyles.CGTDetailsOverview}`}>
        <div className={appStyles.CGTDetailsHeader}>
          <p>Cover your employees for</p>
          <div className={appStyles.CGTDetailsOverviewPrice}>
            <span className={appStyles.QuoteAmount}>
              <span className={appStyles.CurrencyText}>{quoteAmount.substring(0, 1)}</span>
              {isDecimal === -1 ? (
                <span>{quoteAmount.substring(1)}</span>
              ) : (
                <>
                  <span className={appStyles.integerAmount}>{quoteAmount.substring(1, isDecimal)}</span>
                  <span className={appStyles.decimalAmount}>.{quoteAmount.substring(isDecimal + 1)}</span>
                </>
              )}
            </span>
          </div>
          <div className={appStyles.CGTDetailsOverviewInfo}>
            <ul>
              <li>
                <LocationIcon />
                Based in <span id="host_country_state">{quoteData?.companyLocation?.code}</span>
              </li>
              <li>
                <CalendarIcon />
                <span id="total_day">
                  {quoteData?.startDate && quoteData?.endDate
                    ? totalDays(quoteData?.startDate, quoteData?.endDate) + 1
                    : 0}
                </span>
                days
              </li>
              <li>
                <UsersIcon />
                <span id="traveler_count">{quoteData?.numberOfTravellers}</span> people
              </li>
            </ul>
          </div>
        </div>

        <div className={appStyles.CGTDetailsOverviewMainContainer}>
          <div className={appStyles.CGTDetailsOverviewContent}>
            <div className={appStyles.CGTDetailsOverviewHeader}>
              <p>BENEFIT</p>
              <p>MAXIMUM BENEFIT PER PERSON</p>
            </div>
            <div className={appStyles.CGTDetailsRow}>
              <div className={appStyles.CGTDetailsRowParent}>
                <div className={appStyles.CGTDetailsRowCoverage}>
                  <h4>Trip Interruption</h4>
                </div>
                <div className={appStyles.CGTDetailsRowLimit}>
                  <p>
                    <span>Limit </span>100% of non-refundable trip cost
                  </p>
                  <p>Up to maximum of $2,500</p>
                </div>
              </div>
            </div>
            <div className={appStyles.CGTDetailsRow}>
              <div className={appStyles.CGTDetailsRowParent}>
                <div className={appStyles.CGTDetailsRowCoverage}>
                  <h4>Trip Delay</h4>
                </div>
                <div className={appStyles.CGTDetailsRowLimit}>
                  <p>
                    <span>Limit </span>$1,500
                  </p>
                  <p>6 hour minimum</p>
                </div>
              </div>
            </div>
            <div className={appStyles.CGTDetailsRow}>
              <div className={appStyles.CGTDetailsRowParent}>
                <div className={appStyles.CGTDetailsRowCoverage}>
                  <h4>Medical Evacuation and Repatriation of Remains</h4>
                </div>
                <div className={appStyles.CGTDetailsRowLimit}>
                  <p>
                    <span>Limit </span>$25,000
                  </p>
                </div>
              </div>
              <div className={appStyles.CGTDetailsRowChildren}>
                <div className={appStyles.CGTDetailsRowChild}>
                  <p>Emergency Medical Evacuation</p>
                  <div className={appStyles.qtIncluded}>
                    <p>
                      <CheckIcon /> Included
                    </p>
                  </div>
                </div>
                <div className={appStyles.CGTDetailsRowChild}>
                  <p>Medically Necessary Repatriation</p>
                  <div className={appStyles.qtIncluded}>
                    <p>
                      <CheckIcon /> Included
                    </p>
                  </div>
                </div>
                <div className={appStyles.CGTDetailsRowChild}>
                  <p>Repatriation of Remains</p>
                  <div className={appStyles.qtIncluded}>
                    <p>
                      <CheckIcon /> Included
                    </p>
                  </div>
                </div>
                <div className={appStyles.CGTDetailsRowChild}>
                  <p>Medical Escort</p>
                  <div className={appStyles.qtIncluded}>
                    <p>
                      <CheckIcon /> Included
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={appStyles.CGTDetailsRow}>
              <div className={appStyles.CGTDetailsRowParent}>
                <div className={appStyles.CGTDetailsRowCoverage} style={{ width: "70%" }}>
                  <h4> Emergency Accident and Sickness Medical and Dental Expense </h4>
                </div>
                <div className={appStyles.CGTDetailsRowLimit}>
                  <p>
                    <span>Limit </span>$50,000
                  </p>
                  <p>$250 Dental Expense Sub-limit</p>
                </div>
              </div>
            </div>
            <div className={appStyles.CGTDetailsRow}>
              <div className={appStyles.CGTDetailsRowParent}>
                <div className={appStyles.CGTDetailsRowCoverage}>
                  <h4>24 Hour Accidental Death &amp; Dismemberment</h4>
                </div>
                <div className={appStyles.CGTDetailsRowLimit}>
                  <p>
                    <span>Limit </span>$10,000
                  </p>
                  <p>Group aggregate $1,000,000</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={appStyles.CGTDetailsPreExisting}>
          <HeartInsuranceIcon />
          <p>Includes coverage for pre-existing medical conditions.</p>
        </div>
        <div className={appStyles.CGTBasicFormPreFooter}>
          <div className={appStyles.CGTBasicFormBackbtn} onClick={previous}>
            <BackArrowIcon />
            BACK
          </div>
          <button className={appStyles.CGTBasicFormBtnPrimary} onClick={next}>
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default CGQuoteDetail;
